import React from "react"
import { graphql } from "gatsby"
import { FlexibleContent } from "wordsby-components"

import Form from "./form"
import Textarea from "../textarea"
import Table from "./table"
import ProductGallery from "./ProductGallery"
import Banner from "./Banner"
import Button from "./Button"
import BulletList from "./BulletList"
import Downloads from "./Downloads"
import FeaturedLink from "./FeaturedLink"
import ContactInfo from "./ContactInfo"
import LinkBoxes from "./LinkBoxes"

export default ({ rows, data }) => (
  <FlexibleContent
    rows={rows}
    components={{
      form: Form,
      text_area: Textarea,
      table: Table,
      product_gallery: ProductGallery,
      banner: Banner,
      button: Button,
      bullet_list: BulletList,
      downloads: Downloads,
      featured_link: FeaturedLink,
      contact_info: ContactInfo,
      link_boxes: LinkBoxes
    }}
    data={data}
  />
)

export const query = graphql`
  fragment flexibleContent on Node {
    __typename
    ... on WordPressAcf_link_boxes {
      boxes {
        image {
          url {
            childImageSharp {
              fluid(quality: 80, maxWidth: 2560) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        link {
          title
          url
          target
        }
        headline
      }
    }
    __typename
    ... on WordPressAcf_contact_info {
      cards {
        content
        name
        job_title
        contact_numbers {
          number_type
          number
        }
        email
      }
    }
    __typename
    ... on WordPressAcf_featured_link {
      description
      link {
        title
        url
      }
      image {
        url {
          childImageSharp {
            fixed(quality: 80, width: 218) {
              ...GatsbyImageSharpFixed_withWebp_tracedSVG
            }
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_downloads {
      downloads {
        file {
          title
          url {
            publicURL
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_form {
      form_id
    }
    __typename
    ... on WordPressAcf_text_area {
      id
      content
    }
    __typename
    ... on WordPressAcf_table {
      columns {
        table_column {
          table_headline
          table_footer
          table {
            header {
              c
            }
            body {
              c
            }
            caption
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_product_gallery {
      headline
      subline
      gallery {
        id
        title
        filename
        alt
        url {
          publicURL
          childImageSharp {
            fluid(quality: 90, maxWidth: 1280) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_banner {
      image {
        url {
          childImageSharp {
            fluid(quality: 80, maxWidth: 1440) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      headline
      content
    }
    __typename
    ... on WordPressAcf_button {
      button {
        url
        title
        target
      }
    }
    __typename
    ... on WordPressAcf_bullet_list {
      list_column {
        list {
          item
        }
      }
    }
  }
`
